/* Globe
 * A class representing the globe with standard behavior (rotation, zoom)
 * This class has to be instanciated by a child class, as it does not contains the projection type.
 */

import globeProjections from './globes.js';
import { ColorScale } from './colorScales.js';
import Particles from '../model/particles.js';
import {geoCross} from '../utils/utils.js';

export default class Globe {

  constructor(config,size,name) {
    if (globeProjections()[config.projectionName] === undefined) {
      throw new TypeError("Invalid projection name.");
    }
    console.log("CREATING GLOBE", config, size, name);

    this.config = config;
    this.width = size[0];
    this.height = size[1];
    this.precision = 0.1;
    this.name = name;

    this.mapCanvas = $("#" + this.name + "mapcanvas");
    this.pointsSvg = d3.selectAll("svg[id=" + this.name + "pointssvg]");
    this.overlayCanvas = $("#" + this.name + "overlaycanvas");
    this.colorflowCanvas = $("#" + this.name + "overlaycanvas");
    this.legendCanvas = $("#" + this.name + "legendcanvas");
    this.particleCanvas = $("#" + this.name + "particlescanvas");
    this.renderCanvas = $("#" + this.name + "rendercanvas");

    this.mapContext = document.getElementById(this.name +"mapcanvas").getContext("2d");
    this.overlayContext = document.getElementById(this.name +"overlaycanvas").getContext("2d");
    this.colorflowContext = document.getElementById(this.name +"colorflowcanvas").getContext("2d");
    this.legendContext = document.getElementById(this.name +"legendcanvas").getContext("2d");
    this.particleContext = document.getElementById(this.name +"particlescanvas").getContext("2d");
    this.renderContext = document.getElementById(this.name +"rendercanvas").getContext("2d");

    this.overlayImageData = this.overlayContext.createImageData(this.width, this.height);
    this.dataOverlay = this.overlayImageData.data;

    this.mask = math.zeros([this.width,this.height]);
    this.maskToUpdate = true;

    this.colorflowImageData = this.colorflowContext.createImageData(this.width, this.height);
    this.dataColorflow = this.colorflowImageData.data;

    this.obspoints = {};//observbatory points

    this.initDraw();
    this.initGlobe();
  }

  initGlobe() {
    this.canrotate = true;
    this.rotx = 0; //rotation axis for a x mouse move
    this.roty = 1; //rotation axis for a y mouse move
    this.rotating = false;

    this.floatingContinents = false;
    this.allPointVisible = true;

    this.canzoom = true; //no rotation
    this.cantranslate = false;
    this.translX = false;
    this.translY = false;

    this.customGlobe = globeProjections()[this.config.projectionName];
    this.customGlobe.initGlobe.call(this);
    this.path = d3.geoPath().projection(this.projection).context(this.mapContext);
    this.earthSurfacePath = d3.geoPath().projection(this.earthSurfaceProjection).context(this.mapContext);

    var scale = this.getInitScale();
    this.setScale(scale,false);
    this.maskToUpdate = true;

    this.isClearFlow = false;
    this.clearFlow();

    this.selectedPoints = []; //list of point to draw on map
    //$("#" + this.name + "zoombtn").find('.resetzoom').trigger('click'); // Reset ZOOM
  }

  getInitScale() {
    if (!this.customGlobe.getInitScale) {
      return 0.95 * Math.min(this.width,this.height) / 2;
    } else {
      return this.customGlobe.getInitScale.call(this);
    }
  }

  setScale(scale,draw=true) {
    var oldTranslation = this.projection.translate();
    var zoomRatio = scale/this.scale;
    var newtranslation = [this.width / 2 + (oldTranslation[0] - this.width / 2) * zoomRatio,
      this.height / 2 + (oldTranslation[1]  - this.height / 2) * zoomRatio];

    this.scale = scale;
    this.projection.scale(this.scale).translate(newtranslation);
    this.earthSurfaceProjection.scale(this.scale*this.earthSurfaceScaleRatio).translate(newtranslation);

    if (this.customGlobe.setScale) {
      this.customGlobe.setScale.call(this,scale,draw);
    }
    if (draw) {
      this.maskToUpdate = true;
      this.drawMap(true);
    }
  }

  /*
   * Initialize the canvas map by adding globe paths
   */
  initDraw() {
    //this.path = d3.geoPath().projection(this.projection);
    this.graticule = d3.geoGraticule();
    var innerCoreCylinderInterceptAngle = (90 - Math.acos(earthcorevisu.R_INNER_CORE/earthcorevisu.R_OUTER_CORE)*180/Math.PI);
    this.innerCoreCylNorth = d3.geoCircle().center([0,90]).radius(innerCoreCylinderInterceptAngle);
    this.innerCoreCylSouth = d3.geoCircle().center([0,-90]).radius(innerCoreCylinderInterceptAngle);
    this.equator = d3.geoGraticule().stepMinor([0, 90]).stepMajor([0, 90]);

    //load coastline data
    var thisglobe = this;

    d3.json(earthcorevisu.libPath + "/data/110m.json", function(data) {
      thisglobe.coastLo = topojson.feature(data, data.objects.land);
      thisglobe.coastHi = topojson.feature(data, data.objects.land);
    });
    this.coastWidth = 1.5;

    /*d3.json(earthcorevisu.libPath + "/data/50m.json", function(data) {
      thisglobe.coastHi = topojson.feature(data, data.objects.land);
    });*/

    this.lastDraw = Date.now();
    this.lastOverlayDraw = Date.now();
    this.initDone = true;
  }

  setGraticuleSteps(LatStep, LongStep) {
    this.graticule.step([LatStep, LongStep]);
    this.drawMap(true);
  }

  updateCoastWidth(newValue) {
    this.coastWidth = newValue;
    this.drawMap(true);
  }

  /**
   * Calls doDrawMap
   *   - first with rough resolution (at max framerate)
   *   - then with precise one (after a delay)
   */
  drawMap(forceprecise=false,maponly=false,roughoverlay=false,clearFlow=true) {
    clearTimeout(this.drawTimeout);
    clearInterval(this.preciseDrawTimeout);
    var thisglobe = this;
    var nextDraw = this.lastDraw - Date.now() + 1000/earthcorevisu.DRAW_FRAME_RATE;

    var precisedelay = earthcorevisu.PRECISE_DRAW_DELAY;
    if (forceprecise) {
      precisedelay=0;
    }

    this.preciseDrawTimeout = setInterval(function(){
      if (!thisglobe.mouseDown && thisglobe.initDone) {
        clearInterval(thisglobe.preciseDrawTimeout);
        thisglobe.busyDrawing = true;
        thisglobe.mapCanvas.css("cursor","progress");
        setTimeout(function(){
          thisglobe.doDrawMap(false,maponly,roughoverlay,clearFlow).then(function(){
            thisglobe.busyDrawing = false;
            thisglobe.mapCanvas.css("cursor","default");
          });
        },50);
      }
    }, precisedelay);

    if (!forceprecise) {
      if (nextDraw <= 0) {
        setTimeout(function() {thisglobe.doDrawMap(true,maponly,roughoverlay,clearFlow);}, 0); //immediate rough draw
      } else {
        this.drawTimeout = setTimeout(function() {thisglobe.doDrawMap(true,maponly,roughoverlay,clearFlow);}, nextDraw);
      }
    }


  }

  /**
   * Draws the svg map
   * @param rough : lower resolution coastLines and no data field.
   */
  doDrawMap(rough=false,maponly=false,roughoverlay=false,clearFlow=true) {
    var thisglobe = this;
    var continentscale = earthcorevisu.R_EARTH/earthcorevisu.R_OUTER_CORE;
    return new Promise((resolve, reject) => {
      thisglobe.cancelDraw = false;
      thisglobe.lastDraw = Date.now();

      //Clear overlay if rough draw
      var coastData = thisglobe.coastLo;
      if (!rough) {
        coastData = thisglobe.coastHi;
      }

      // DRAWS MAP (earth-core)
      thisglobe.mapContext.clearRect(0, 0, thisglobe.width, thisglobe.height);
      console.log(thisglobe.mapContext);
      thisglobe.mapContext.strokeStyle = "rgba(255,255,255,0.7)";

      var path = (thisglobe.config.showCore ? thisglobe.path : thisglobe.earthSurfacePath);
      if (thisglobe.config.showCore || (!thisglobe.floatingContinents)) {
        thisglobe.mapContext.beginPath();
        path(thisglobe.innerCoreCylNorth());
        path(thisglobe.innerCoreCylSouth());
        thisglobe.mapContext.lineWidth = 2.5;
        thisglobe.mapContext.stroke();
        if (thisglobe.cancelDraw) {reject(); return;}

        thisglobe.mapContext.strokeStyle = "rgba(255,255,255,0.5)";

        thisglobe.mapContext.beginPath();
        path(thisglobe.graticule());
        thisglobe.mapContext.lineWidth = 1;

        path(thisglobe.equator());
        thisglobe.mapContext.lineWidth = 2;

        path({type: "Sphere"});
        thisglobe.mapContext.lineWidth = 1.5;
        if (thisglobe.cancelDraw) {reject(); return;}
        thisglobe.mapContext.stroke();

        thisglobe.mapContext.strokeStyle = "rgba(255,255,255,0.8)";
        thisglobe.mapContext.beginPath();
        path(coastData);
        thisglobe.mapContext.lineWidth = this.coastWidth;
        if (thisglobe.cancelDraw) {reject(); return;}
        thisglobe.mapContext.stroke();
      }

      //clear points canvas
      path = thisglobe.path;
      path.context(undefined);
      thisglobe.pointsSvg.selectAll(".selectedpoint").remove();

      //User selected point on globe
      for (var center of thisglobe.selectedPoints) {
        var cross = geoCross(center,600/thisglobe.scale);
        thisglobe.pointsSvg.append("path")
           .attr("d", path(cross))
           .attr("class","selectedpoint")
           .style("fill", (thisglobe.floatingContinents ? "rgb(0,0,0)" : "rgb(255,255,255)"));
      }
      //Points (i.e. observatories)
      if (thisglobe.config.points.show) {
        $("#"+thisglobe.name+"pointssvg").hide();//hide to avoid svg repaint
        //romove obsType that are no more displayed
        for (var obsType in thisglobe.obspoints) {
          if (!thisglobe.config.points.data.hasOwnProperty(obsType)){
            for (var strpos in thisglobe.obspoints[obsType]) {
              thisglobe.obspoints[obsType][strpos].point.remove();
            }
            thisglobe.obspoints[obsType] = {};
          }
        }
        for (var obsType in thisglobe.config.points.data) {
          if (!thisglobe.obspoints.hasOwnProperty(obsType)) {
            //build points dict
            thisglobe.obspoints[obsType] = {};
          }

          //show observatories
          thisglobe.projection.scale(thisglobe.scale / earthcorevisu.R_OUTER_CORE * thisglobe.config.points.data[obsType].r);
          var pointconfig = thisglobe.config.points.data[obsType].pointconfig;

          for (var position of thisglobe.config.points.data[obsType].coordinates) {
            var strpos = position.toString();
            if (!thisglobe.obspoints[obsType].hasOwnProperty(strpos)) {
              var size = (pointconfig.size == null ? 300/thisglobe.scale : pointconfig.size);
              var center = this.spherToGeo(position);
              var shape = d3.geoCircle().center(center).radius(size)();
              if (pointconfig.shape == "cross") {
                shape = geoCross(center,size);
              }
              thisglobe.obspoints[obsType][strpos] = {}
              thisglobe.obspoints[obsType][strpos].shape = shape;
              thisglobe.obspoints[obsType][strpos].point = thisglobe.pointsSvg.append("path")
                 .attr("d", path(shape))
                 .attr("fill-opacity", 0.3)
                 .attr("pos", strpos)
                 .attr("obstype", obsType)
                 .attr("pointname", pointconfig.name)
                 .attr("class","obspoint")
                 .style("fill", (pointconfig.fill === undefined ? "rgb(0,0,0)" : pointconfig.fill))
                 .style("stroke", (pointconfig.stroke === undefined ? "rgb(0,0,0)" : pointconfig.stroke));
            }
            else {
              thisglobe.obspoints[obsType][strpos].point.attr("d", path(thisglobe.obspoints[obsType][strpos].shape));
            }
          }
        }
        $(".obspoint") //Obs point interactions
            .off()
            .on("mouseup",function(){
              $(thisglobe.config.parentDivName).trigger("mouseup"); //fix to end dragging when mouse up on an svg element
            })
            .on("mouseenter",function(){
              var $this = $(this);
              if (thisglobe.isDragging) {return;}
              //remove old hovered
              if (thisglobe.pointHovered != null) {
                thisglobe.pointHovered.path.attr("fill-opacity",0.3);
              }
              thisglobe.pointHovered = {"pos":$this.attr("pos"), "obstype": $this.attr("obstype"), "path":$this};
              thisglobe.pointHovered.path.attr("fill-opacity", 0.6);
              if (thisglobe.pointSelected != null) {
                thisglobe.pointSelected.path.attr("fill-opacity", 1);
              }
              if (thisglobe.pointSelected == null) {
                //trigger on change
                if (thisglobe.config.points.mouseover != null) {
                  thisglobe.config.points.mouseover($this.attr("pos").split(","), $this.attr("obstype"));
                }
              }
            })
            .on("mouseleave",function(){
              if (thisglobe.pointSelected != null) {return;}
              if (thisglobe.isDragging) {return;}

              if (thisglobe.pointHovered != null) {
                thisglobe.pointHovered.path.attr("fill-opacity",0.3);
              }
              thisglobe.pointHovered = null;
              if (thisglobe.pointSelected != null) {
                thisglobe.pointSelected.path.attr("fill-opacity", 1);
              } else {
                thisglobe.config.points.mouseout();
              }
            })
            .on("click",function(){
              var $this = $(this);
              if ((thisglobe.pointSelected != null) &&
                  ($this.attr("pos") == thisglobe.pointSelected.pos) &&
                  ($this.attr("obstype") == thisglobe.pointSelected.obstype)){
                //unselect
                thisglobe.pointSelected.path.attr("fill-opacity",0.6);
                thisglobe.pointHovered = thisglobe.pointSelected;
                thisglobe.pointSelected = null;
              } else {
                //select
                if (thisglobe.pointSelected != null) {
                  thisglobe.pointSelected.path.attr("fill-opacity",0.3);
                }
                thisglobe.pointSelected = thisglobe.pointHovered;
                thisglobe.pointHovered = null;
                thisglobe.pointSelected.path.attr("fill-opacity", 1);
                if (thisglobe.config.points.mouseover != null) {
                  thisglobe.config.points.mouseover($this.attr("pos").split(","), $this.attr("obstype"));
                }
              }
            });
        $("#"+thisglobe.name+"pointssvg").show();//show to repaint svg
      }
      thisglobe.projection.scale(thisglobe.scale);
      path.context(thisglobe.mapContext);

      if (thisglobe.floatingContinents) {
        thisglobe.mapContext.strokeStyle = "rgba(0,0,0,0.1)";
        var clipAngleCore = (thisglobe.config.showCore ? 146.8 : 180);
        thisglobe.earthSurfaceProjection.clipAngle(clipAngleCore);

        thisglobe.mapContext.beginPath();
        thisglobe.earthSurfacePath(thisglobe.equator());
        thisglobe.mapContext.lineWidth = 3;
        thisglobe.mapContext.stroke();
        if (thisglobe.cancelDraw) {reject(); return;}

        thisglobe.earthSurfaceProjection.clipAngle(90);

        thisglobe.earthSurfacePath(thisglobe.graticule());
        thisglobe.mapContext.lineWidth = 1;
        thisglobe.mapContext.stroke();
        if (thisglobe.cancelDraw) {reject(); return;}

        thisglobe.earthSurfacePath({type: "Sphere"});
        thisglobe.mapContext.lineWidth = 1.5;
        thisglobe.mapContext.stroke();
        if (thisglobe.cancelDraw) {reject(); return;}

        thisglobe.mapContext.fillStyle = "rgb(90,90,90)";
        thisglobe.mapContext.beginPath();
        thisglobe.earthSurfaceProjection.clipAngle(clipAngleCore);
        thisglobe.earthSurfacePath(coastData);
        thisglobe.mapContext.fill();

        thisglobe.mapContext.fillStyle = "rgb(60,60,60)";
        thisglobe.mapContext.beginPath();
        thisglobe.earthSurfaceProjection.clipAngle(90);
        thisglobe.earthSurfacePath(coastData);
        thisglobe.mapContext.fill();
      }
      if (!rough) {
        if (!maponly) {

          if (thisglobe.cancelDraw) {reject(); return;}
          var drawOverlay = (thisglobe.config.overlay.data && thisglobe.config.overlay.show);
          var drawColorFlow = (thisglobe.config.flow.data && thisglobe.config.flow.show);
          thisglobe.drawOverlays(drawOverlay,drawColorFlow);
          if (!drawOverlay) {
            thisglobe.clearOverlay(false,true);
          }
          if (thisglobe.config.flow.data && thisglobe.config.flow.show && thisglobe.isClearFlow) {
            thisglobe.animateFlow(clearFlow);
          }
        }
      } else {
        if (roughoverlay) {
          thisglobe.drawRoughOverlay();
        } else {
          thisglobe.clearOverlay(false);
        }
      }

      if (thisglobe.floatingContinents) {
        thisglobe.mapCanvas.css("mix-blend-mode","hard-light");
      } else {
        thisglobe.mapCanvas.css("mix-blend-mode","difference");
      }

      resolve();
    });

  }

  updateMask() {
    this.maskToUpdate = false;
      // Create a detached canvas, ask the model to define the mask polygon, then fill with an opaque color.
    var canvas = d3.select(document.createElement("canvas")).attr("width", this.width).attr("height", this.height).node();
    var context = canvas.getContext("2d");

    if (this.config.overlay.earthSurface) {
      d3.geoPath().projection(this.earthSurfaceProjection).context(context)({type: "Sphere"});
    } else {
      d3.geoPath().projection(this.projection).context(context)({type: "Sphere"});
    }

    context.fillStyle = "rgba(255, 0, 0, 1)";
    context.fill();

    var imageData = context.getImageData(0, 0, this.width, this.height);
    var data = imageData.data;  // layout: [r, g, b, a, r, g, b, a, ...]

    for (var x=0; x<this.width; x++) {
      for (var y=0; y<this.height; y++) {
        this.mask[x][y] = (data[(y * this.width + x) * 4 + 3] > 0);
      }
    }
  }

  isInsideMask(x,y) {
    if (this.maskToUpdate) {
      this.updateMask();
    }
    try{
      return this.mask[Math.round(x)][Math.round(y)];
    } catch (e) {
      return false;
    }
  }

  /**
   * Returns geographical coordinates (l : latitude,λ : longitude)
   * @param  : θ,φ Spherical coodirnates
   */
  spherToGeo(θφ) {
    if (θφ === null) {return null;}
    var θ = θφ[0];
    var φ = θφ[1] % 360;
    var l = (90 - θ) % 180;
    var λ = (φ + 360) % 360;
    if (λ > 180) {
      λ = λ - 360;
    }
    return [λ,l];
  }

  /**
   * Returns spherical coordinates (θ : azimuthal angle, φ : polarl angle)
   * @param  : θ,φ Spherical coodirnates
   */
  geoToSpher(λl) {
    if (λl === null) {return null;}
    var λ = λl[0] % 360;
    var l = λl[1];
    var θ = (90 - l);
    var φ = (λ + 360) % 360;
    return [θ,φ];
  }

  clearOverlay(clearall=true) {
    if (!this.isClearOverlay) {
      this.isClearOverlay = true;
      this.isClearAllOverlay = false;
      this.overlayContext.clearRect(0,0,this.width,this.height);
    }
    if (!clearall) {
      this.isClearAllOverlay = true;
      this.overlayContext.clearRect(0,0,this.width,this.height);
      if (this.floatingContinents) {//draw inner core
        this.overlayContext.beginPath();
        d3.geoPath().projection(this.earthSurfaceProjection).context(this.overlayContext)({type: "Sphere"});
        //this.overlayContext.fillStyle = "rgba("+this.colorScale.scale.range()[0].join(",")+",0.85)";
        this.overlayContext.fillStyle = this.config.overlay.hiddenColor;
        this.overlayContext.fill();
      }
      //draw outcore core
      this.overlayContext.beginPath();
      d3.geoPath().projection(this.projection).context(this.overlayContext)({type: "Sphere"});
      this.overlayContext.fillStyle = this.config.overlay.hiddenColor;
      this.overlayContext.fill();
    }
  }

  drawOverlays(drawOverlay=true,drawColorFlow=true,rough=false) {
    drawOverlay = this.config.overlay.show && drawOverlay && this.config.overlay.data;
    drawColorFlow = drawColorFlow && this.config.flow.data;
    var projection = (this.config.overlay.earthSurface ? this.earthSurfaceProjection : this.projection);

    if (!drawOverlay && !drawColorFlow) {return;}
    this.cancelDraw = false;
    this.isClearOverlay = false;
    var width = this.width;
    var height = this.height;
    for (var x=0;x<width;x++) {
      if (this.cancelDraw) {return;}
      for (var y=0;y<height;y++) {
        var i = (y * width + x) * 4;
        if (this.isInsideMask(x,y)) {
          var λl = projection.invert([x,y]);
          if (λl !== undefined) {
            if (drawOverlay) {
              var value = this.config.overlay.data.interpolateValue(this.geoToSpher(λl)); //get magnitude
              var color = this.colorScale.scale(value);
              this.dataOverlay[i  ] = color[0];
              this.dataOverlay[i+1] = color[1];
              this.dataOverlay[i+2] = color[2];
              this.dataOverlay[i+3] = 255;
            }
            if (drawColorFlow) {
              var value = this.config.flow.data.interpolateValue(this.geoToSpher(λl),this.config.flow.colorScaleData); //get magnitude
              var color = this.flowColorScale.scale(value);
              this.dataColorflow[i  ] = color[0];
              this.dataColorflow[i+1] = color[1];
              this.dataColorflow[i+2] = color[2];
              this.dataColorflow[i+3] = 255;
            }
          }
        }
        else {//point outside mask
          if (this.config.overlay.show && drawOverlay) {this.dataOverlay[i+3] = 0;}
          if (drawColorFlow && this.config.flow.data) {this.dataColorflow[i+3] = 0;}
        }
      }
    }
    if (drawOverlay) {
      this.overlayContext.putImageData(this.overlayImageData, 0, 0);
    }
    if (drawColorFlow) {
      this.colorflowContext.putImageData(this.colorflowImageData, 0, 0);
    }
  }

  drawRoughOverlay() {
    var thisGlobe = this;
    var projection = (this.config.overlay.earthSurface ? this.earthSurfaceProjection : this.projection);
    var nextOverlayDraw = Math.max(10,this.lastOverlayDraw - Date.now() + 1000/earthcorevisu.DRAW_FRAME_RATE); //draw rough overlay 10 times/s
    clearTimeout(this.drawOverlayTimeOut);

    thisGlobe.drawOverlayTimeOut = setTimeout(function(){
      this.lastOverlayDraw = Date.now();
      var drawOverlay = thisGlobe.config.overlay.show && thisGlobe.config.overlay.data;
      if (!drawOverlay) {return;}
      var step=8;
      thisGlobe.cancelDraw = false;
      thisGlobe.isClearOverlay = false;
      var width = thisGlobe.width;
      var height = thisGlobe.height;
      var λl,value,color;
      for (var x=0;x<width;x+=step) {
        if (thisGlobe.cancelDraw) {return;}
        for (var y=0;y<height;y+=step) {
          var i = (y * width + x) * 4;
          λl = undefined;
          if (thisGlobe.isInsideMask(x,y)) {
            λl = projection.invert([x,y]);
            if (λl !== undefined) {
              value = thisGlobe.config.overlay.data.interpolateValue(thisGlobe.geoToSpher(λl)); //get magnitude
              color = thisGlobe.colorScale.scale(value);
            }
          }
          for (var xs=-Math.ceil(step/2);xs<Math.floor(step/2);xs++){
            for (var ys=-Math.ceil(step/2);ys<Math.floor(step/2);ys++){
              i = ((y+ys) * width + (x+xs)) * 4;
              if (λl !== undefined && thisGlobe.isInsideMask(x+xs,y+ys)) {
                thisGlobe.dataOverlay[i  ] = color[0];
                thisGlobe.dataOverlay[i+1] = color[1];
                thisGlobe.dataOverlay[i+2] = color[2];
                thisGlobe.dataOverlay[i+3] = 255;
              } else {
                thisGlobe.dataOverlay[i+3] = 0;
              }
            }
          }
        }
      }
      thisGlobe.overlayContext.putImageData(thisGlobe.overlayImageData, 0, 0);
    }, nextOverlayDraw);
  }

  clearFlow() {
    if (!this.isClearFlow) {
      clearInterval(this.drawFlowInterval);
      this.isClearFlow = true;
      this.particleContext.globalCompositeOperation = "source-over";
      this.particleContext.clearRect(0,0,this.width,this.height);
    }
  }

  animateFlow(clearFlow=true) {
    if (clearFlow) {
      this.clearFlow();
      this.isClearFlow = false;
    }
    if (!this.particles) {
      this.particles = new Particles(this);
    }
    clearInterval(this.drawFlowInterval);
    if (this.config.flow.fps>0) {
      var thisglobe = this;
      this.drawFlowInterval = setInterval(function(){
        thisglobe.particles.evolve();
        thisglobe.particles.draw();
      },1/thisglobe.config.flow.fps*1000);
    }
  }

  setColorScale(colorscaleName, invert=false, logColors=false, draw=true) {
    this.colorScale =  new ColorScale(earthcorevisu.colorScales.scales[colorscaleName],invert,logColors,colorscaleName.startsWith('Div'));

    if (draw && this.config.overlay.show) {
      this.drawOverlays(true,false);
    }
  }

  setFlowColorScale(colorscaleName, invert=false, logColors=false, draw=true) {
    if (colorscaleName in earthcorevisu.colorScales.scales) {
      this.flowColorScale =  new ColorScale(earthcorevisu.colorScales.scales[colorscaleName],invert,logColors,colorscaleName.startsWith('Div'));
      if (this.config.flow.data) {
        this.flowColorScale.setDomain([this.config.flow.data.magmin, this.config.flow.data.magmax]);
      }
    }

    if (draw) {
      this.drawOverlays(false,true);
    }
  }

}



//////////////////
// WEBPACK FOOTER
// ./src/model/globe.js
// module id = 15
// module chunks = 0